import {
  Directive,
  ElementRef,
  Output,
  EventEmitter,
  HostListener
} from '@angular/core'

/**
 * Emits an event when a click outside the directive occures
 */
@Directive({
    selector: '[aioClickOutside]',
    standalone: false
})
export class ClickOutsideDirective {
  // eslint-disable-next-line no-useless-constructor
  constructor(private elementRef: ElementRef) {}

  /**
   * Event emitted when a click outside this component occures
   */
  @Output() appClickOutside = new EventEmitter()

  /**
   * Seek a click in the application and outside the current component.
   * If there is, emit the event
   */
  @HostListener('document:click', ['$event.target'])
  public onClick(targetElement) {
    const clickedInside = this.elementRef.nativeElement.contains(targetElement)
    if (!clickedInside) {
      this.appClickOutside.emit(null)
    }
  }
}
